import React from 'react';
import { Stack, Alert, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import useStudioStore from '../state/studioStore';

export default function GlobalAlerts() {
  const notifications = useStudioStore((state) => state.notifications);
  const dismissNotification = useStudioStore((state) => state.dismissNotification);

  if (!notifications || notifications.length === 0) {
    return null;
  }

  return (
    <Stack
      spacing={1}
      sx={{
        position: 'fixed',
        top: 80,
        right: 24,
        maxWidth: 360,
        zIndex: (theme) => theme.zIndex.snackbar,
      }}
    >
      {notifications.map((notification) => (
        <Alert
          key={notification.id}
          severity={notification.severity || 'info'}
          action={
            <IconButton
              size="small"
              aria-label="close"
              color="inherit"
              onClick={() => dismissNotification(notification.id)}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          }
        >
          {notification.message}
        </Alert>
      ))}
    </Stack>
  );
}
